import * as Types from '../constants/Types';
import {PAGINATION} from '../constants/Define';

const initialState = {
    isSubmit: false,
    isFail: false,
    isGetItem: false,
    isFetchingUpdate: false,
    isFetching: false,
    dataList: [],
    pageSize: PAGINATION.pageSize,
    pageIndex: PAGINATION.pageIndex,
    totalCount: PAGINATION.totalCount,
};

export default (state = initialState , action) => {
    switch (action.type) {
        case Types.LOCATION_LIST_ACTION:
            return {...state,isFetching: true, dataList: []};
        case Types.LOCATION_LIST_SUCCESS:
            return {
                ...state, 
                isFetching: false, 
                dataList: action.dataList, 
                isSubmit: false,
                pageSize: action.pageSize,
                pageIndex: action.pageIndex,
                totalCount: action.totalCount,
                totalPage: Math.ceil(parseInt(action.totalCount) / parseInt(action.pageSize))
            };
        case Types.LOCATION_DETAIL_ACTION:
            return {...state,isFetching: true, location: {}};
        case Types.LOCATION_DETAIL_SUCCESS:
            return {...state, isFetching: false, location: action.location};
        case Types.LOCATION_SAVE_ACTION:
                return {...state,isFetching: true, location: action.location};
        case Types.LOCATION_SAVE_SUCCESS:
            return {...state, isFetching: false, location: action.location};
        case Types.LOCATION_DELETE_ACTION:
                return {...state,isFetching: true, location: action.location};
        case Types.LOCATION_DELETE_SUCCESS:
            return {...state, isFetching: false, location: {}};
        default:
            return state;
    }
}
